import styled from 'styled-components';
import { tokens } from 'styles/tokens';
import { PageBoxProps } from './PageBox';

export const Wrapper = styled.div<PageBoxProps>`
	background-color: ${tokens.color_white};
	margin: ${({ margin }) => margin};
	min-height: ${({ minHeigth, height }) => (height ? height : minHeigth)};
	height: ${({ height }) => height && height};
	position: relative;
`;

export const WrapperHeader = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const WrapperIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${tokens.color_primary};
	color: ${tokens.color_white};
	font-weight: 800;
	border-radius: 50%;

	width: 60px;
	height: 60px;
	top: -40px;

	@media (max-width: 1200px) {
		width: 55px;
		height: 55px;
	}

	@media (max-width: 992px) {
		width: 50px;
		height: 50px;
	}

	@media (max-width: 768px) {
		width: 45px;
		height: 45px;
	}

	@media (max-width: 600px) {
		width: 40px;
		height: 40px;
	}
`;

export const Icon = styled.img`
	height: 30px;

	@media (max-width: 1200px) {
		height: 27.5px;
	}

	@media (max-width: 992px) {
		height: 25px;
	}

	@media (max-width: 768px) {
		height: 22.5px;
	}

	@media (max-width: 600px) {
		height: 20px;
	}
`;

export const WrapperTitle = styled.div`
	font-weight: 600;
	font-size: 20px;
	color: ${tokens.color_primary};
	margin: 28px 0 0 0;
`;

export const WrapperBottomActions = styled.div<{ buttonPadding?: string }>`
	display: flex;
	justify-content: end;
	margin: 4vh -20px 2vh 0vw;
	${({ buttonPadding }) => buttonPadding && `padding: ${buttonPadding};`}

	button:nth-child(n) {
		margin-left: 2vw;
	}
`;
